<template>
    <div class="form-group">
        <label :for="getId"
               v-text="getLabel"
        ></label>
        <textarea
            data-input
            maxlength="191"
            :id="getId"
            class="form-control"
            v-model="currentValue"
            :rows="rowCount"
        ></textarea>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';

    export default {
        mixins: [
            fieldInfo,
        ],
        computed: {
            rowCount() {
                return this.currentValue.split(/\r\n|\r|\n/).length;
            },
        }
    }
</script>

<style scoped>
    .form-control {
        resize: none;
    }
</style>
